import { render, staticRenderFns } from "./SpecChoose.vue?vue&type=template&id=c75680c0&scoped=true"
import script from "./SpecChoose.vue?vue&type=script&lang=js"
export * from "./SpecChoose.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c75680c0",
  null
  
)

export default component.exports